module.exports = __webpack_public_path__ + "img/chat-quote-fill.850e2829.svg";